"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClubDate_1 = __importDefault(require("helpers/ClubDate"));
const File_1 = require("helpers/File");
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const intersectionBy_1 = __importDefault(require("lodash/intersectionBy"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const unionBy_1 = __importDefault(require("lodash/unionBy"));
const mobx_1 = require("mobx");
const FileService_1 = __importDefault(require("modules/file/FileService"));
const helpers_1 = require("modules/file/helpers");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const ui_1 = require("modules/ui");
const constants_1 = require("./constants");
require("./SalesApi");
const SalesConstants_1 = require("./SalesConstants");
const SalesStore_1 = __importDefault(require("./SalesStore"));
const request_1 = __importDefault(require("@hotmart/request"));
class SalesService {
    async enableLifetimeAccess() {
        try {
            this.addConfig('LIFETIME_ACCESS');
            ui_1.UiService.setAlertSuccess('done');
            return true;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return false;
        }
    }
    async disableLifetimeAccess() {
        try {
            this.removeConfig('LIFETIME_ACCESS');
            ui_1.UiService.setAlertSuccess('done');
            return true;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return false;
        }
    }
    async enableAccessPlus() {
        await this.addConfig('MEMBERSHIP_GROUPS_ENABLED');
    }
    async disableAccessPlus() {
        await this.removeConfig('MEMBERSHIP_GROUPS_ENABLED');
    }
    async addConfig(config) {
        await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.PutConfigAdd, { config });
        await MembershipService_1.default.fetchData();
    }
    async removeConfig(config) {
        await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.DeleteConfig, { config });
        await MembershipService_1.default.fetchData();
    }
    async getOffers() {
        try {
            const offers = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetOffers);
            this.setData({ offers });
            return offers;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return [];
    }
    async getMainOffers() {
        try {
            const mainOffers = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetMainOffers);
            return mainOffers;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return [];
    }
    addValue(offers = []) {
        return (offers.length &&
            offers.map((item) => {
                item.value = item.key;
                return item;
            }));
    }
    groupOffers(offers) {
        return (0, groupBy_1.default)(offers, 'periodicity');
    }
    hasElWithProperty(offers, prop) {
        let filteredOffers = [];
        if (Array.isArray(offers)) {
            filteredOffers = offers.filter((el) => {
                return el[prop] && el[prop] !== null;
            });
        }
        return filteredOffers.length > 0;
    }
    addPeriodicitySubHeaders(offers) {
        const keys = Object.keys(offers);
        keys.forEach((key) => {
            const el = {
                name: `general.periodicity.${key.toLowerCase()}`,
                amount: offers[key].length,
                type: 'subheader'
            };
            offers[key].unshift(el);
        });
        return offers;
    }
    getSubHeader(offers) {
        const subheader = {
            name: 'general.name',
            type: 'subheader'
        };
        if (this.hasElWithProperty(offers, 'price')) {
            subheader.price = 'general.price';
        }
        if (this.hasElWithProperty(offers, 'class')) {
            subheader.class = 'general.class';
        }
        return subheader;
    }
    formatOffers(offers) {
        offers = this.addValue(offers);
        if (this.hasElWithProperty(offers, 'periodicity')) {
            const groupedOffers = this.groupOffers(offers);
            const formatedOffers = this.addPeriodicitySubHeaders(groupedOffers);
            return formatedOffers;
        }
        return offers;
    }
    findCorrespondyClassName(offer, classes) {
        for (let i = 0; i < classes.length; i++) {
            const offers = classes[i].offers;
            for (let j = 0; j < offers.length; j++) {
                if (offer.key === offers[j].offerKey) {
                    return classes[i].name;
                }
            }
        }
    }
    addClass(offers = [], classes) {
        if (Array.isArray(classes)) {
            const defaultClass = classes.find((item) => item.defaultClass === true);
            offers.length &&
                offers.map((item) => {
                    item.class = this.findCorrespondyClassName(item, classes);
                    if (!item.class) {
                        item.class = defaultClass.name;
                    }
                    return item;
                });
        }
        return offers;
    }
    async getClasses() {
        try {
            const data = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetMembershipClassAndOffersBySubdomain);
            return data;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    }
    async fetchMembershipGroupSelectedOffers() {
        try {
            const data = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetGroupsInfo);
            return data;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return [];
    }
    async updateGroupsInfo(data) {
        const enabledAccessPlus = data.accessPlusToggle;
        const newSelectedOffers = data.offersCheckList;
        try {
            enabledAccessPlus
                ? await this.enableAccessPlus()
                : await this.disableAccessPlus();
            await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.PutGroupsInfo, this.parseGroupsOffersToJson(newSelectedOffers));
            ui_1.UiService.setAlertSuccess('done');
        }
        catch (error) {
            if (error) {
                ui_1.UiService.handleError(error);
            }
            else {
                ui_1.UiService.setAlertError('default_error');
            }
        }
    }
    parseGroupsOffersToJson(selectedOffers = []) {
        const newGroupOffers = { offers: [] };
        selectedOffers.forEach((offer) => {
            newGroupOffers.offers.push({ offerKey: offer });
        });
        return newGroupOffers;
    }
    async getSalesInfoData() {
        try {
            const [data, freeSignUp] = await Promise.all([
                (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetSalesInfo),
                (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetSignupAllowed)
            ]);
            return { ...(data || {}), freeSignUp: freeSignUp || false };
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return null;
    }
    async getSignupAllowed() {
        try {
            return await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetSignupAllowed);
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return false;
    }
    async getShowAccessPlus() {
        try {
            const data = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetAccessPlusShow);
            return data;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return false;
    }
    async getIsAccessPlus() {
        try {
            const data = await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetIsAccessPlus);
            return data;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return false;
    }
    getImageID(media) {
        let id = null;
        if (media && !(0, helpers_1.isVideo)(media)) {
            id = media.fileId || media.id;
        }
        return id;
    }
    getVideoID(media) {
        let id = null;
        if (media && (0, helpers_1.isVideo)(media)) {
            id = media.fileId || media.id;
        }
        return id;
    }
    async getMediasIds(id) {
        if (!id) {
            return;
        }
        let media = null;
        let image = null;
        try {
            media = await FileService_1.default.fetchSalesMedia(id);
            if (!media || (0, isEmpty_1.default)(media)) {
                try {
                    image = await FileService_1.default.fetchSalesImage(id);
                }
                catch (error) {
                    ui_1.UiService.handleError(error);
                }
            }
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
        return { image, media };
    }
    async updateSalesInfo({ media, description, selectedOffers, receivedSelectedOffers, mediaVideoUrl, freeSignUp }) {
        const intersectionOffers = (0, intersectionBy_1.default)(receivedSelectedOffers, selectedOffers, 'offerKey');
        const uniqueOffers = (0, unionBy_1.default)(intersectionOffers, selectedOffers, 'offerKey');
        const imageId = this.getImageID(media);
        const mediaId = this.getVideoID(media);
        const subdomain = MembershipService_1.default.subdomain;
        const data = {
            description,
            offers: uniqueOffers,
            imageId,
            mediaId,
            mediaVideoProvider: mediaVideoUrl
                ? (0, File_1.parseMediaUrl)(mediaVideoUrl).type
                : null,
            mediaVideoUrl,
            allowSignup: freeSignUp
        };
        try {
            await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.PostFreeSignup, { subdomain }, {
                data
            });
            this.hideSalesOfferAlert();
            ui_1.UiService.setAlertSuccess('done');
        }
        catch (error) {
            if (error) {
                ui_1.UiService.handleError(error);
            }
            else {
                ui_1.UiService.setAlertError('default_error');
            }
            throw error;
        }
    }
    async saveFreeSignup(data, subdomain) {
        try {
            await (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.PostFreeSignup, { subdomain }, {
                data
            });
            this.hideSalesOfferAlert();
            ui_1.UiService.setAlertSuccess('activate_module');
        }
        catch (error) {
            if (error) {
                ui_1.UiService.handleError(error);
            }
            else {
                ui_1.UiService.setAlertError('default_error');
            }
            throw error;
        }
    }
    isOfferMatch(selectedOffer, offer) {
        const selectedOfferId = selectedOffer.offerKey;
        const offerId = offer.key || offer.value;
        return selectedOfferId === offerId;
    }
    fetchAlert(alertType) {
        return (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.GetSalesDiaglogAlert, {
            'alert-type': alertType
        });
    }
    async fetchSalesOfferAlert() {
        try {
            const response = await this.fetchAlert(constants_1.SALES_ALERT.OFFER_NOT_FOUND_SALES_INFORMATION_PAGE);
            this.setData({ showableSalesOfferAlert: Boolean(response) });
        }
        catch (_a) { }
    }
    async fetchDashboardOfferAlert() {
        try {
            const response = await this.fetchAlert(constants_1.SALES_ALERT.OFFER_NOT_FOUND_HOME_PAGE);
            this.setData({ showableDashboardOfferAlert: Boolean(response) });
        }
        catch (_a) { }
    }
    sendUserEvent(eventName) {
        const data = {
            eventName,
            eventDate: new ClubDate_1.default().to.seconds()
        };
        return (0, request_1.default)(SalesConstants_1.SalesEndpointKeys.PostUserAreaEvent, data);
    }
    async sendSalesOfferEvent() {
        if (!SalesStore_1.default.showableSalesOfferAlert) {
            return;
        }
        try {
            await this.sendUserEvent(constants_1.USER_EVENT.OFFER_NOT_FOUND_SALES_PAGE_DISMISSED);
            this.hideSalesOfferAlert();
        }
        catch (_a) { }
    }
    async sendDashboardOfferEvent() {
        if (!SalesStore_1.default.showableDashboardOfferAlert) {
            return;
        }
        try {
            await this.sendUserEvent(constants_1.USER_EVENT.OFFER_NOT_FOUND_HOME_DISMISSED);
            this.hideDashboardOfferAlert();
        }
        catch (_a) { }
    }
    hideSalesOfferAlert() {
        this.setData({ showableSalesOfferAlert: false });
    }
    hideDashboardOfferAlert() {
        this.setData({ showableDashboardOfferAlert: false });
    }
    setData(data) {
        Object.assign(SalesStore_1.default, { ...data });
    }
}
__decorate([
    mobx_1.action
], SalesService.prototype, "fetchSalesOfferAlert", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "fetchDashboardOfferAlert", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "sendSalesOfferEvent", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "sendDashboardOfferEvent", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "hideSalesOfferAlert", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "hideDashboardOfferAlert", null);
__decorate([
    mobx_1.action
], SalesService.prototype, "setData", null);
exports.default = new SalesService();
